import type { Dictionary } from '../bs'
import { common } from './common'
import { auth } from './auth'
import { shell } from './shell'
import { home } from './home'
import { submissions } from './submissions'
import { tasks } from './tasks'
import { fiveS } from './fiveS'
import { profile } from './profile'
import { notifications } from './notifications'
import { analytics } from './analytics'
import { admin } from './admin'
import { guide } from './guide'
import { owner } from './owner'
import { people } from './people'

/**
 * English, written out in full and derived from nothing.
 *
 * `hr` and `sr` inherit from `bs` because they are the same language with a
 * handful of words changed. English shares nothing with it, so inheriting would
 * mean a forgotten key silently renders Bosnian on an English screen — a
 * half-translated interface that looks finished.
 *
 * The `Dictionary` annotation below is what prevents that, and it is the reason
 * this is not `Partial`: leave a key out and the build fails, naming it. Each
 * slice carries the same guarantee individually, so the error points at the
 * screen rather than at this file.
 *
 * The audience is not so much a native speaker as anyone in the building who
 * does not read the local language — a visiting auditor, a supplier's engineer.
 * So the words are the plain factory ones.
 */
export const en: Dictionary = {
  ...common,
  ...auth,
  ...shell,
  ...home,
  ...submissions,
  ...tasks,
  ...fiveS,
  ...profile,
  ...notifications,
  ...analytics,
  ...admin,
  ...guide,
  ...owner,
  ...people,
}
